const styles = (theme) => ({
  root: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent:'space-between',
  },
  driverName: {
    color: theme.tooltipText,
    overflow: "hidden",
    alignItems: "center",
    textOverflow: 'ellipsis'
  },
  tooltip: {
    padding: 0,
    fontSize: theme.textFontSize,
    maxWidth: '100%'
  },
  recommendationContainer: {
    backgroundColor: theme.ModalBGColor,
    height: '101px',
    width: '387px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  errorLabel: {
    color: theme.TextColor,
    fontSize: theme.textFontSize
  },
  loader: {
    alignSelf: 'center',
    marginRight: 20,
  },
  customTooltip: {
    opacity: 1,
  },
  assignButton: {
    marginLeft: 10,
  },
  noteTooltip: {
    backgroundColor: theme.tooltipBGColor,
    color: theme.tooltipText,
    boxShadow: `0px 0px 2px 0px ${theme.tooltipBorderColor}`,
    borderRadius: 2,
    padding: 5,
    fontSize: theme.textFontSize,
    opacity: 1,
    wordBreak: "break-word",
  },
  noteTooltipWarning: {
    color: theme.warningColor, 
    fontSize: 18,
    marginRight: 6,
    verticalAlign: "middle"
  },
  noFeasibleDriver:{
    fontStyle:"italic",
    opacity: 0.8,
    paddingRight:4,
    lineHeight:"18px"
  },
  recommendationKPIBorder: {
    border: `1px solid ${theme.recommendationKPIBorder}`,
  }
});

export default styles;
